const storeTypes = {
  SET_LOCATION: "SET LOCATION",
  SET_HAS_PARTNER: "HAS PARTNER",
  SET_HAS_CHILDREN: "HAS CHILDREN",
  SET_HAS_OTHER_CHILDREN: "HAS OTHER CHILDREN",
  SET_REGISTER_EMAIL: "SET REGISTER EMAIL",
  SET_LOGGED_IN: "USER LOGIN",
  SET_ADMIN_LOGGED_IN: "ADMIN LOGIN",
  SET_USER_DETAILS: "USER DETAILS",
  SET_REDIRECT: "SET REDIRECT",
};

export default storeTypes;
